/*
  بيانات تجريبية لإنشاء أمر العمل في نسخة العرض فقط (REACT_APP_DEMO=true).
  تحاكي ردود الخادم: عقدان، قوائم كل عقد، ملحق أسعار، ومسودات ومرفقات في الذاكرة.
  لا يُستورد هذا الملف إلا من وضع العرض، فلا يدخل النسخة الحقيقية.
*/

let seq = 1000;
const id = () => ++seq;

const contracts = [
  { id: 1, contractNumber: "101", name: "العقد الموحد بالرياض", shortName: "الرياض", kind: "Unified", isActive: true },
  { id: 2, contractNumber: "205", name: "عقد حائل", shortName: "حائل", kind: "Unified", isActive: true },
];

const departments = {
  1: [{ id: 11, contractId: 1, name: "إدارة إنشاءات الرياض", branchId: 1, branchName: "الرياض", isActive: true }],
  2: [{ id: 21, contractId: 2, name: "إدارة إنشاءات حائل", branchId: 2, branchName: "حائل", isActive: true }],
};

const values = [];
function v(contractId, category, name, extra = {}) {
  const row = { id: id(), contractId, category, name, code: null, description: null, parentId: null, departmentId: null, ...extra };
  values.push(row);
  return row;
}
[[1, "الرياض", "R", "مؤسسة النور للمقاولات", "شركة البناء الحديث", ["حي النزهة", "حي الملقا"]],
 [2, "حائل", "H", "شركة الشمال للمقاولات", "مؤسسة حائل الهندسية", ["حي النقرة", "حي السمراء"]]].forEach(
  ([c, city, p, k1, k2, districts]) => {
    v(c, "WorkOrderType", "عام");
    const cons = v(c, "WorkOrderType", "إنشاءات");
    v(c, "WorkOrderType", "صيانة");
    v(c, "WorkOrderCodeSet", `${p}-801`, { code: `${p}-S-801`, description: "تمديد شبكة أرضية" });
    v(c, "WorkOrderCodeSet", `${p}-802`, { code: `${p}-S-802`, description: "إيصال خدمة لمشترك" });
    v(c, "WorkOrderCodeSet", `${p}-803`, { code: `${p}-S-803`, description: "إزالة تعارض مع الخدمات" });
    v(c, "ActivityType", "إيصال خدمة", { parentId: cons.id });
    v(c, "ActivityType", "تعزيز شبكة", { parentId: cons.id });
    v(c, "Contractor", k1, { code: `${p}C1` });
    v(c, "Contractor", k2, { code: `${p}C2` });
    v(c, "Office", `مكتب ${city} الرئيسي`);
    districts.forEach((d) => v(c, "District", d));
    v(c, "VoltageLevel", "جهد منخفض LV", { code: "LV" });
    v(c, "VoltageLevel", "جهد متوسط MV", { code: "MV" });
  }
);

const pricing = [
  { id: 1001, itemNumber: "1.01", shortDescription: "حفر خندق للكابلات", uom: "م.ط", unitPrice: 45.5, branchId: 1, contractId: 1, isActive: true },
  { id: 1002, itemNumber: "1.02", shortDescription: "تمديد كابل 3x185", uom: "م.ط", unitPrice: 120, branchId: 1, contractId: 1, isActive: true },
  { id: 1003, itemNumber: "2.10", shortDescription: "تركيب لوحة توزيع", uom: "عدد", unitPrice: 3500, branchId: 1, contractId: 1, isActive: true },
  { id: 2001, itemNumber: "H1.01", shortDescription: "حفر خندق", uom: "م.ط", unitPrice: 40, branchId: 2, contractId: 2, isActive: true },
];

const drafts = new Map();
const lastImports = {};
const attachments = new Map();

const norm = (s) => String(s ?? "").toLowerCase();
const ok = (data, status = 200, headers = {}) => ({ data, status, headers });
const fail = (status, message) => ({ error: { status, data: { message } } });

/** يعيد { data } أو { error } أو null إن لم يكن الطلب من طلبات أمر العمل. */
export function handleWorkOrderDemo(method, rawUrl, params = {}, body) {
  const url = rawUrl.toLowerCase().replace(/^.*\/api\//, "").replace(/^\//, "");
  const json = typeof body === "string" ? safeJson(body) : body;

  if (method === "get" && url.startsWith("contractworkflow/contracts") && !url.includes("/departments")) return ok(contracts);
  const dep = url.match(/^contractworkflow\/contracts\/(\d+)\/departments/);
  if (dep) return ok(departments[dep[1]] || []);

  if (url.startsWith("contractsetup/lists")) {
    const cid = Number(params.contractId);
    let rows = values.filter((x) => x.contractId === cid && x.category === params.category);
    if (params.parentId) rows = rows.filter((x) => x.parentId === Number(params.parentId));
    if (params.search) rows = rows.filter((x) => [x.name, x.code, x.description].some((f) => norm(f).includes(norm(params.search))));
    return ok(rows);
  }

  // ملحق أسعار العقد (بنود المقايسة مربوطة برقم العقد)
  const cp = url.match(/^contractpricing\/(\d+)\/(items|summary|import)/);
  if (cp) {
    const cid = Number(cp[1]);
    const mine = pricing.filter((p) => p.contractId === cid);
    if (cp[2] === "items") {
      const q = norm(params.search);
      const items = mine.filter((p) => p.isActive && (!q || norm(p.shortDescription).includes(q) || norm(p.itemNumber).includes(q)));
      return ok({ items, totalCount: items.length });
    }
    if (cp[2] === "summary") {
      const c = contracts.find((x) => x.id === cid);
      return ok({ contract: c, activeItems: mine.filter((p) => p.isActive).length, inactiveItems: 0, lastImport: lastImports[cid] || null });
    }
    const rows = (json?.items || []).filter((r) => r.itemNumber);
    const byNum = new Map(mine.map((p) => [String(p.itemNumber), p]));
    const toCreate = rows.filter((r) => !byNum.has(String(r.itemNumber)));
    const changes = rows.filter((r) => byNum.has(String(r.itemNumber)) && Number(byNum.get(String(r.itemNumber)).unitPrice) !== Number(r.unitPrice))
      .map((r) => ({ itemNumber: r.itemNumber, previousPrice: byNum.get(String(r.itemNumber)).unitPrice, unitPrice: r.unitPrice, priceChanged: true }));
    if (json?.apply) {
      toCreate.forEach((r) => pricing.push({ id: id(), itemNumber: r.itemNumber, shortDescription: r.shortDescription, uom: r.uom, unitPrice: r.unitPrice, branchId: 0, contractId: cid, isActive: true }));
      changes.forEach((c) => { byNum.get(String(c.itemNumber)).unitPrice = c.unitPrice; });
      lastImports[cid] = { at: new Date().toISOString(), by: "مدير النظام (عرض)" };
    }
    return ok({ applied: !!json?.apply, toCreate: toCreate.length, toUpdate: changes.length, unchanged: rows.length - toCreate.length - changes.length,
      notInFile: mine.filter((p) => !rows.some((r) => String(r.itemNumber) === String(p.itemNumber))).length, changes, errors: [] });
  }

  if (url.startsWith("pricingitems")) {
    const q = norm(params.search);
    const items = pricing.filter((p) => p.branchId === Number(params.branchId) && (!q || norm(p.shortDescription).includes(q) || p.itemNumber.includes(q)));
    return ok({ items, totalCount: items.length });
  }

  if (url.startsWith("workorderdrafts/check-number")) {
    return ok({ valid: true, exists: false, inDrafts: [], message: null });
  }
  const fin = url.match(/^workorderdrafts\/(\d+)\/finalize/);
  if (fin) return ok({ constructionId: 1, alreadyConverted: false });
  const one = url.match(/^workorderdrafts\/(\d+)$/);
  if (url === "workorderdrafts" && method === "get") {
    return ok([...drafts.values()].map((d) => ({
      id: d.id, contractId: d.contractId, contractNumber: contracts.find((c) => c.id === d.contractId)?.contractNumber,
      contractName: contracts.find((c) => c.id === d.contractId)?.name, faultNumber: d.data.faultNumber, workOrderTypeName: d.data.workOrderType,
      workOrderCode: d.data.consultantWorkOrderCode || d.data.contractorWorkOrderCode, contractorName: d.data.contractor, lastStep: d.lastStep, completionPercent: d.completionPercent,
      updatedAt: d.updatedAt, createdByName: "مدير النظام (عرض)", canDelete: true,
    })));
  }
  if (url === "workorderdrafts" && method === "post") {
    const d = { id: id(), contractId: json.contractId, data: json.data, lastStep: json.lastStep, completionPercent: json.completionPercent, updatedAt: new Date().toISOString() };
    drafts.set(d.id, d);
    return ok({ id: d.id, updatedAt: d.updatedAt });
  }
  if (one && method === "put") {
    const d = drafts.get(Number(one[1]));
    if (!d) return fail(404, "المسودة غير موجودة.");
    Object.assign(d, { data: json.data, lastStep: json.lastStep, completionPercent: json.completionPercent, updatedAt: new Date().toISOString() });
    return ok({ id: d.id, updatedAt: d.updatedAt });
  }
  if (one && method === "get") {
    const d = drafts.get(Number(one[1]));
    if (!d) return fail(404, "المسودة غير موجودة.");
    const c = contracts.find((x) => x.id === d.contractId);
    return ok({ ...d, status: "Draft", contractNumber: c.contractNumber, contractName: c.name, attachmentsCount: [...attachments.values()].filter((a) => a.draftId === d.id).length });
  }
  if (one && method === "delete") {
    drafts.delete(Number(one[1]));
    return ok(null, 204);
  }

  if (url.startsWith("workorderattachments")) return attachmentsDemo(method, url, params, json, body);
  if (url.startsWith("workorderevents")) return eventsDemo(method, url, params, json);
  const gc = url.match(/^construction\/get-construction\/(\d+)/);
  if (gc) return ok({ statusCode: 200, message: "", data: demoConstruction(Number(gc[1])) });
  return null;
}

// ───────────── سجل أحداث أمر العمل (عرض) ─────────────

const DEMO_PEOPLE = [
  { id: "u-ma", name: "محمد أحمد", userName: "mohamed", role: "مهندس", emailHint: "m***@asf.sa", hasAccess: true },
  { id: "u-ka", name: "خالد علي", userName: "khaled.ali", role: "مشرف", emailHint: "k***@asf.sa", hasAccess: true },
  { id: "u-aa", name: "أحمد عبدالله", userName: "ahmed", role: "مهندس", emailHint: "a***@asf.sa", hasAccess: true },
  { id: "u-sm", name: "سارة محمود", userName: "sara", role: "مهندس", emailHint: "s***@asf.sa", hasAccess: true },
  { id: "u-km", name: "خالد محمد", userName: "khaled", role: "مدير مكتب", emailHint: "k***@asf.sa", hasAccess: true },
  { id: "u-out", name: "فهد السالم", userName: "fahad", role: "مقاول", emailHint: "f***@asf.sa", hasAccess: false },
];
const CATS = { WorkOrder: "أمر العمل", Items: "بنود الأعمال", Execution: "التنفيذ", Workflow: "المراحل والإجراءات", Attachments: "المرفقات", Notes: "الملاحظات", Mentions: "الإشارات", Financial: "البيانات المالية", System: "النظام" };
const eventStore = new Map();
let eventSeq = 500;

function demoConstruction(id) {
  return {
    id, faultNumber: "261033909", workOrderType: "إنشاءات", contractor: "شركة الإنشاءات الحديثة", district: "حي النزهة",
    office: "مكتب الرياض الرئيسي", orderDate: "2026-09-15T00:00:00", receiveDateTime: "2026-09-15T00:00:00",
    workDescription: "أعمال إنشاء وتأهيل الطرق الداخلية", durationOfImplementation: "45", situation: "تحت التنفيذ",
    implementationPhase: "التصاريح", estimatedValue: "64500", actualValue: "29050", branchName: "الرياض", pricingItems: [],
  };
}

function seedEvents(woId) {
  const P = Object.fromEntries(DEMO_PEOPLE.map((p) => [p.name, p]));
  const at = (daysAgo, h, m) => { const d = new Date(); d.setDate(d.getDate() - daysAgo); d.setHours(h, m, 0, 0); return d.toISOString(); };
  const E = (who, daysAgo, h, m, category, type, title, description, extra = {}) => ({
    id: ++eventSeq, workOrderId: woId, type, category, categoryLabel: CATS[category], title, description,
    userId: who ? P[who].id : null, userName: who || "النظام", createdAt: at(daysAgo, h, m), mentions: [], source: who ? "User" : "System", ...extra,
  });
  const list = [
    E("محمد أحمد", 6, 8, 30, "WorkOrder", "WorkOrderCreated", "إنشاء أمر العمل", "قام محمد أحمد بإنشاء أمر العمل رقم 261033909.",
      { metadata: { workOrderType: "إنشاءات", contractor: "شركة الإنشاءات الحديثة", district: "حي النزهة", duration: "45" } }),
    E("محمد أحمد", 6, 8, 31, "Items", "ItemsAddedOnCreate", "بنود الأعمال عند الإنشاء", "تمت إضافة بندي أعمال مع إنشاء أمر العمل.",
      { metadata: { items: [{ itemNumber: "1005", description: "أعمال الحفر", quantity: 250, unit: "م³" }, { itemNumber: "1006", description: "أعمال الردم", quantity: 500, unit: "م³" }] } }),
    E("خالد محمد", 5, 14, 10, "Workflow", "PhaseChanged", "تغيير مرحلة", "قام خالد محمد بنقل أمر العمل من مرحلة المسح الميداني إلى مرحلة التصاريح.",
      { oldValue: "المسح الميداني", newValue: "التصاريح", metadata: { label: "مرحلة التنفيذ" } }),
    E("سارة محمود", 3, 9, 10, "Attachments", "AttachmentAdded", "إضافة مرفق", "قام سارة محمود بإضافة المرفق «مخطط الموقع العام».",
      { metadata: { files: [{ name: "مخطط الموقع العام.pdf" }] } }),
    E("أحمد عبدالله", 2, 9, 45, "Items", "ItemAdded", "إضافة بند أعمال", "قام أحمد عبدالله بإضافة البند رقم 12245 – حفر خندق للكابل بكمية 250 م.",
      { newValue: "250 م", metadata: { itemNumber: "12245", description: "حفر خندق للكابل", unit: "م", quantity: 250, unitPrice: 45.5, total: 11375 } }),
    E("أحمد عبدالله", 2, 9, 46, "Financial", "EstimatedValueChanged", "تغيير القيمة التقديرية", "قام أحمد عبدالله بتعديل القيمة التقديرية من 53,125 ريال إلى 64,500 ريال.",
      { oldValue: "53,125 ريال", newValue: "64,500 ريال", metadata: { label: "القيمة التقديرية", unit: "ريال", difference: 11375 } }),
    E("خالد علي", 1, 10, 30, "Mentions", "NoteAdded", "ملاحظة", "@محمد أحمد نأمل سرعة اتخاذ اللازم.",
      { mentions: [{ id: 1, userId: "u-ma", userName: "محمد أحمد" }] }),
    E("محمد أحمد", 0, 10, 42, "Execution", "DailyExecutionAdded", "تحديث تنفيذ", "قام محمد أحمد بإضافة تحديث تنفيذي للبند رقم 1005 بكمية 50 م³.",
      { oldValue: "120 م³", newValue: "170 م³", metadata: { itemNumber: "1005", description: "أعمال الحفر", unit: "م³", previous: 120, current: 170, difference: 50, executionPercentage: 68 } }),
  ];
  // سجل أطول لإظهار التحميل التدريجي
  for (let i = 0; i < 116; i += 1) {
    const who = DEMO_PEOPLE[i % 5].name;
    list.push(E(who, 7 + Math.floor(i / 6), 8 + (i % 9), (i * 7) % 60, "Execution", "DailyExecutionAdded", "تحديث تنفيذ",
      `قام ${who} بإضافة تحديث تنفيذي للبند رقم 1006 بكمية ${5 + (i % 4) * 5} م³.`,
      { metadata: { itemNumber: "1006", description: "أعمال الردم", unit: "م³" } }));
  }
  return list.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
}

function eventsDemo(method, url, params, json) {
  const m = url.match(/^workorderevents\/(\d+)(?:\/(users|mention-candidates|notes))?/);
  if (!m) return method === "post" ? fail(400, "إعادة الإرسال غير متاحة في نسخة العرض.") : null;
  const woId = Number(m[1]);
  if (!eventStore.has(woId)) eventStore.set(woId, seedEvents(woId));
  const all = eventStore.get(woId);

  if (m[2] === "users") {
    const counts = {};
    all.forEach((e) => { counts[e.userName] = (counts[e.userName] || 0) + 1; });
    return ok(Object.entries(counts).map(([name, count]) => ({ id: all.find((e) => e.userName === name).userId || `name:${name}`, name, count })));
  }
  if (m[2] === "mention-candidates") {
    const q = norm(params.search);
    return ok(DEMO_PEOPLE.filter((p) => !q || norm(p.name).includes(q) || norm(p.userName).includes(q)));
  }
  if (m[2] === "notes" && method === "post") {
    const text = String(json?.text || "").trim();
    if (!text) return fail(400, "اكتب نص الملاحظة.");
    const mentioned = DEMO_PEOPLE.filter((p) => (json.mentionedUserIds || []).includes(p.id) && text.includes(`@${p.name}`));
    const ev = {
      id: ++eventSeq, workOrderId: woId, type: "NoteAdded", category: mentioned.length ? "Mentions" : "Notes",
      categoryLabel: CATS[mentioned.length ? "Mentions" : "Notes"], title: "ملاحظة", description: text,
      userId: "demo-admin", userName: "مدير النظام (عرض)", createdAt: new Date().toISOString(), source: "User",
      mentions: mentioned.map((p, i) => ({ id: eventSeq * 10 + i, userId: p.id, userName: p.name })),
    };
    all.unshift(ev);
    return ok(ev);
  }

  let rows = [...all];
  const cat = params.category;
  if (cat) rows = rows.filter((e) => (cat === "Notes" ? e.category === "Notes" || e.category === "Mentions" : e.category === cat));
  if (params.userId) rows = rows.filter((e) => (e.userId || `name:${e.userName}`) === params.userId);
  if (params.from) rows = rows.filter((e) => e.createdAt >= params.from);
  if (params.to) rows = rows.filter((e) => e.createdAt < params.to);
  if (params.search) {
    const q = norm(params.search);
    rows = rows.filter((e) => norm(JSON.stringify(e)).includes(q));
  }
  if (params.order === "asc") rows.reverse();
  const start = params.cursor ? Number(atob(params.cursor)) : 0;
  const take = Number(params.take || 50);
  const page = rows.slice(start, start + take);
  return ok({
    workOrder: { workOrderId: woId, workOrderNumber: "261033909", contractId: 1, contractName: "101 — العقد الموحد بالرياض", canAddNotes: true },
    categories: Object.entries(CATS).map(([key, label]) => ({ key, label })),
    total: all.length, matching: rows.length,
    nextCursor: start + take < rows.length ? btoa(String(start + take)) : null,
    items: page,
  });
}

function attachmentsDemo(method, url, params, json, body) {
  const list = (draftId) => [...attachments.values()].filter((a) => a.draftId === draftId).sort((a, b) => a.sortOrder - b.sortOrder);
  if (method === "get" && url === "workorderattachments") return ok(list(Number(params.draftId)).map(publicRow));
  if (method === "post" && url === "workorderattachments" && body instanceof FormData) {
    const file = body.get("file");
    const draftId = Number(body.get("draftId"));
    const ext = (file.name.match(/\.[^.]+$/) || [""])[0].toLowerCase();
    const a = {
      id: id(), draftId, displayName: body.get("displayName") || file.name, originalFileName: file.name, extension: ext,
      contentType: file.type || "application/octet-stream", sizeBytes: file.size, sortOrder: list(draftId).length + 1,
      uploadedAt: new Date().toISOString(), uploadedByName: "مدير النظام (عرض)", blob: file,
    };
    attachments.set(a.id, a);
    return ok({ id: a.id, displayName: a.displayName, sortOrder: a.sortOrder });
  }
  if (method === "put" && url === "workorderattachments/order") {
    (json.ids || []).forEach((aid, i) => { const a = attachments.get(aid); if (a) a.sortOrder = i + 1; });
    return ok(null, 204);
  }
  const m = url.match(/^workorderattachments\/(\d+)(?:\/(view|download))?$/);
  if (m) {
    const a = attachments.get(Number(m[1]));
    if (!a) return fail(404, "المرفق غير موجود.");
    if (m[2]) return ok(a.blob, 200, { "content-type": a.contentType });
    if (method === "put") { a.displayName = json.displayName; return ok({ id: a.id, displayName: a.displayName }); }
    if (method === "delete") { attachments.delete(a.id); return ok(null, 204); }
  }
  if (url === "workorderattachments/merge") {
    return fail(400, "دمج المرفقات في PDF واحد يتم في الخادم، وغير متاح في نسخة العرض.");
  }
  return null;
}

const publicRow = (a) => {
  const previewable = [".pdf", ".jpg", ".jpeg", ".png", ".webp"].includes(a.extension);
  return { ...a, blob: undefined, previewable, mergeable: previewable, canEdit: true, canDelete: true };
};

function safeJson(s) {
  try {
    return JSON.parse(s);
  } catch {
    return {};
  }
}
